<template>
  <v-footer
    id="core-footer"
    absolute
    height="62"
  >
    <v-spacer/>
    <span class="font-weight-light">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
          class="copyright"
          href="https://esite-iq.com/"
          target="_blank">eSITE Information Technology</a>,
      <a
        class="copyright"
        target="_blank" href="http://hvdlifesciences.com">HVD Lifesciences</a>
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
    ]
  })
}
</script>

<style scoped>
.copyright a {
  color: black;
}

#core-footer {
  z-index: 0;
}
</style>
